"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotlightControls = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

var _SpotlightOverlay = require("../SpotlightOverlay");

var _Tracker = require("../../util/Tracker");

var _TRCToggle = _interopRequireDefault(require("../../TRCToggle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Spotlight Controls
var SpotlightControls = function SpotlightControls(_ref) {
  var moment = _ref.moment,
      updates = _ref.updates,
      startAt = _ref.startAt,
      setStartAt = _ref.setStartAt,
      spotlightEnabled = _ref.spotlightEnabled,
      setSpotlightEnabled = _ref.setSpotlightEnabled,
      spotlightOverlayRef = _ref.spotlightOverlayRef,
      onChangeOverlayStyles = _ref.onChangeOverlayStyles,
      originalRelativeStartAt = _ref.originalRelativeStartAt,
      videoQuerySelector = _ref.videoQuerySelector,
      previewQuerySelector = _ref.previewQuerySelector,
      x = _ref.x,
      y = _ref.y,
      setX = _ref.setX,
      setY = _ref.setY;

  var onToggleSpotlight = function onToggleSpotlight(e) {
    if (typeof setSpotlightEnabled === "function") {
      (0, _Tracker.trackEvent)({
        action: "Spotlight turned ".concat(spotlightEnabled ? "OFF" : "ON"),
        element: e.currentTarget
      });
      setSpotlightEnabled(!spotlightEnabled);
    }
  };

  var onForward = function onForward(e, noOfSeconds) {
    e.preventDefault();
    var newTime = startAt + noOfSeconds;
    var max = updates.stopAtRelative - 0.5;

    if (newTime > max) {
      newTime = max;
    }

    setStartAt(newTime);
  };

  var onBackward = function onBackward(e, noOfSeconds) {
    e.preventDefault();
    var newTime = startAt - noOfSeconds;

    if (newTime < updates.startAtRelative + 0.5) {
      newTime = updates.startAtRelative + 0.5;
    }

    console.log('NewTime', newTime);
    setStartAt(newTime);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!spotlightEnabled && /*#__PURE__*/_react.default.createElement(_SpotlightOverlay.SpotlightOverlay, {
    onChangeOverlayStyles: onChangeOverlayStyles,
    spotlightOverlayRef: spotlightOverlayRef,
    x: x,
    y: y,
    setX: setX,
    setY: setY,
    videoQuerySelector: videoQuerySelector,
    previewQuerySelector: previewQuerySelector
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "personalize-controls-spotlight",
    marginTop: "6",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: "Spotlight",
    marginTop: "4",
    marginBottom: "4",
    color: _atoms.Color.Grey2,
    bold: true,
    type: _atoms.Label.Type.Heading5
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_TRCToggle.default, {
    checked: spotlightEnabled,
    onToggle: function onToggle(e) {
      return onToggleSpotlight(e);
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    marginTop: "10"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: "Spotlight time",
    marginTop: "4",
    marginBottom: "4",
    color: _atoms.Color.Grey2,
    bold: true,
    type: _atoms.Label.Type.Heading5
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginRight: "4",
    width: "var(--spacing-9x)",
    trkAction: "Spotlight -2 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.Back2,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onBackward(e, 2);
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginRight: "4",
    width: "var(--spacing-9x)",
    trkAction: "Spotlight -0.5 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.JumpBack05,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onBackward(e, 0.5);
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: (startAt - originalRelativeStartAt).toFixed(1),
    marginTop: "4",
    marginBottom: "4",
    color: _atoms.Color.Black,
    type: _atoms.Label.Type.Body
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginLeft: "4",
    width: "var(--spacing-9x)",
    trkAction: "Spotlight +0.5 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.JumpFwd05,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onForward(e, 0.5);
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginLeft: "4",
    width: "var(--spacing-9x)",
    trkAction: "Spotlight +2 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.Forward2,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onForward(e, 2);
    }
  })))));
};

exports.SpotlightControls = SpotlightControls;
SpotlightControls.defaultProps = {
  time: 0.0
};